
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.75 3.896V18.1c0 .99-1.168 1.514-1.907.857l-4.117-3.662a.688.688 0 00-.457-.173H3.896a2.062 2.062 0 01-2.063-2.062V8.937a2.063 2.063 0 012.063-2.062h3.373c.169 0 .331-.062.457-.174l4.116-3.66c.74-.658 1.908-.133 1.908.855zm3.66 1.51a.688.688 0 01.96.143 9.13 9.13 0 011.797 5.452 9.13 9.13 0 01-1.797 5.45.688.688 0 01-1.105-.818A7.754 7.754 0 0018.792 11a7.754 7.754 0 00-1.527-4.633.688.688 0 01.144-.962zm-1.696 2.266a.688.688 0 01.933.277c.491.908.77 1.948.77 3.052a6.392 6.392 0 01-.77 3.05.689.689 0 01-1.21-.654c.398-.736.606-1.56.605-2.396 0-.87-.22-1.685-.605-2.397a.687.687 0 01.277-.932z"}})])
          )
        }
      }
    